/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { practiceLocationIndex } from "parog-web/cnam-adapters/utils";
import type { PracticeLocation } from "parog-web/cnam/types";
import type DmpConnectJSAuthenticationContextAdapter from "parog-web/contexts/dmpconnect-js/authentication-context-adapter";

interface Args {
  context: DmpConnectJSAuthenticationContextAdapter;
}

export default class CnamServicesAccessFormAuthenticationSetPracticeLocationComponent extends Component<Args> {
  get practiceLocation(): string | undefined {
    return this.args.context.practiceLocation;
  }

  get updatePracticeLocation(): boolean {
    return Boolean(this.args.context.updatePracticeLocation);
  }

  declare availablePracticeLocations: PracticeLocation[];
  declare tempPracticeLocation?: string;

  @tracked selectedPracticeLocationIndex: number;
  invalidPracticeLocation = false;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    this.availablePracticeLocations =
      this.args.context.availableLocations ||
      this.args.context.cpsInformations?.practiceLocations ||
      [];

    if (!this.practiceLocation) {
      this.selectedPracticeLocationIndex = -1;
    } else {
      const index = practiceLocationIndex(
        this.practiceLocation,
        this.availablePracticeLocations
      );

      this.selectedPracticeLocationIndex = index;

      if (index === -1) {
        this.invalidPracticeLocation = true;
      }

      this.tempPracticeLocation = this.practiceLocation;
    }
  }

  @action
  selectPracticeLocation(newIndex: number): void {
    this.selectedPracticeLocationIndex = newIndex;
    this.invalidPracticeLocation = false;
    this.tempPracticeLocation =
      this.availablePracticeLocations[newIndex].structureName;
  }

  @action
  onSubmit(event: Event): void {
    event.preventDefault();
    this.args.context.practiceLocation = this.tempPracticeLocation as string;
    this.tempPracticeLocation = undefined;
    this.args.context.transitionTo();
  }
}
